(function() {
  "use strict";

  angular

    .module('modules.dataServices')

    .service("DataService", ['$http', '$q', 'DataCache',

      function($http, $q, DataCache) {

        this.getData = function(resourcePath, resourceName) {

          var data = {
            loading: true,
            records: [],
            promise: null
          };

          resourcePath = resourcePath.replace(/\/+$/gm, '');

          // These services have been updated to use an API rather than
          // a shared controller for page and JSON responses.
         
          data.promise = $http.get(resourcePath, {
            cache: DataCache,
            params: {
              "json": "true"
            },
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            }
          })
            .then(function(result) {
              if (resourceName) {
                return result.data[resourceName];
              }

              return result.data;
            });


          // This lets you use the service in a simple Angular-y way, just
          // wait for the promise to resolve internally, and let $digest
          // discover the data.
          data.promise
            .then(function(results) {
              angular.copy(results, data.records);
            });

          return data;

        };



      this.postData = function($http, $q, DataCache, payLoad) {

        return function(resourcePath, resourceName) {

          var data = {
            loading: true,
            records: [],
            promise: null
          };

          resourcePath = resourcePath.replace(/\/+$/gm, '');

          data.promise = $http.post(resourcePath, payLoad, {
            cache: DataCache,
            params: {
              "json": "true"
            },
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            }
          })
            .then(function(result) {
              if (resourceName) {
                return result.data[resourceName];
              }

              return result.data;
            });


          // This lets you use the service in a simple Angular-y way, just
          // wait for the promise to resolve internally, and let $digest
          // discover the data.
          data.promise
            .then(function(results) {
              angular.copy(results, data.records);
            });

          return data;

        };

      }
    }
    ]);

})();
